import { cannedWorkTaskQuery } from "@common/api/quoting/canned"
import {
  createFileRoute,
  getRouteApi,
  Outlet,
  useNavigate,
} from "@tanstack/react-router"
import { TaskPane } from "../../-components/task-pane"
import { TaskStepper } from "../../-components/task-stepper"

const listRoute = getRouteApi("/_layout/templates/tasks")

export const Route = createFileRoute("/_layout/templates/tasks/$taskId")({
  staticData: { detailSidebar: true },
  loader: ({ context: { queryClient }, params: { taskId } }) =>
    queryClient.fetchQuery(cannedWorkTaskQuery({ task_id: taskId })),
  component: TemplateTaskRoute,
})

function TemplateTaskRoute(): React.ReactElement {
  const { taskId } = Route.useParams()
  const filters = listRoute.useSearch()
  const navigate = useNavigate()

  return (
    <TaskPane
      taskId={taskId}
      onClose={() => navigate({ to: "/templates/tasks", search: true })}
      actions={
        <TaskStepper
          taskId={taskId}
          filters={filters}
          packageId={null}
          onOpen={(id) =>
            navigate({
              to: "/templates/tasks/$taskId",
              params: { taskId: id },
              search: true,
            })
          }
        />
      }
    >
      <Outlet />
    </TaskPane>
  )
}
